const PriUniData = [
    {
        thumb: '../img/privateuni-thumb/sim-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/yzd56jxMHcQ',
        img: '../img/privateuni-thumb/sim-main.jpg',
        title: 'SIM',
        fullTitle: 'Singapore Institute of Management',
        student: '~23,000명',
        semester: '1월 | 4월 | 7월 | 10월',
        fee:'~$S35,000',
        intro: 'SIM은 1964년에 설립되었고 사립교육 기관 중 가장 규모가 크고 최신식 시설의 캠퍼스를 보유하여 학생들들에게 각종 편의 시설을  제공하고 학생회및 다양한 클럽 활동을 통해 네트워크 형성에도 많은 도움을 주며 30가지 이상의 장학금 제도를 운영 학생들의 학업 성취도 향상에 기여 하고 있습니다. '
    },
    {
        thumb: '../img/privateuni-thumb/mdis-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/MXwr7je_MhU',
        img: '../img/privateuni-thumb/mdis-main.jpg',
        title: 'MDIS',
        fullTitle: 'Management Development Institute of Singapore',
        student: '~10,000명',
        semester: '1월 | 4월 | 7월 | 10월',
        fee:'~$S35,000',
        intro: '싱가포르의 사립대학교중 가장 오래된 학교로 1956년에 설립되었습니다. 학교내에 유일하게 기숙사를 보유하고 있는 장점과 가장 큰 캠퍼스를 자랑하고 있습니다.세계 여러 국적의 10000여명의 학생들이 재학중이며 경영학, 생명공학, 기계공학, IT, 패션, 호텔경영등 다양한 전공을 제공합니다.영국, 호주,미국등 우수한 대학과 제휴를 맺고 있습니다.'
    },
    {
        thumb: '../img/privateuni-thumb/laselle-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/1yncX2oUDrg',
        img: '../img/privateuni-thumb/laselle-main.jpg',
        title: 'Laselle',
        fullTitle: 'Lasalle College Of The Arts',
        student: '~10,000명',
        semester: '8월',
        fee:'~$S75,000',
        intro: '예술대학으로 최고의 수준을 자랑하는 Lasalle College of Art는 사립대학으로 1984년에 설립되었으며 학교 경관이 멋스러우며  접근성이 매우 편리한 장점을 가지고 있습니다. 고등학교를 졸업하면 디그리 과정으로 바로들어갈 수 있고 디플로마 과정은 싱가폴 정부의GT(장학금)을  지원 받을 수 있습니다. Lasalle College of Art는 미술분야와 퍼포먼스 분야로 구분되며 30여개 이상의 프로그램이 개설되어있고 본교 교수진과 세계 우수한 교수들을 초빙해 다양한 강의를 제공합니다. 학업을 마치면 영국 예술분야의 명문 런던 대학교 골드스미스 학위를 취득하게 됩니다.'
    },
    {
        thumb: '../img/privateuni-thumb/psb-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/gksNxhlpQMk',
        img: '../img/privateuni-thumb/psb-main.jpg',
        title: 'PSB',
        fullTitle: 'PSB Academy Singapore',
        student: '~11,000명',
        semester: '1월 | 4월 | 7월 | 10월',
        fee:'~$S34,000',
        intro: '1964년 설립된 학교로 현재 1,1000 여명의 학생이 재학중이며 호주와 영국등 우수한 대학들과 제휴를 통해 80여개 이상의 많은 프로그램을 제공하고 있습니다. 싱가포르내에 두개의 캠퍼스를 가지고 있으며 시티 캠퍼스는 어학과정, 호텔경영, 경영학등이 개설되어 있고 메인 캠퍼스는 생명과학, 엔지니어링등의 과정을 제공합니다. 최고의 실험실을 보유하여 학생들의 실력향상을 위해 애쓰고 있으며 학생들에게 좋은 평가를 받고 있습니다. 유망 학과로는 경영정보, 유아교육, 호텔경영, 심리학이 있습니다.'
    },
    {
        thumb: '../img/privateuni-thumb/raffles-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/pSWr7mBoZNw',
        img: '../img/privateuni-thumb/raffles-main.jpg',
        title: 'Raffles',
        fullTitle: 'Raffles College of Higher Education',
        student: '~10,000명',
        semester: '1월 | 4월 | 7월 | 10월',
        fee:'~$S96,000',
        intro: '1990년 Raffles 교육그룹에 의해 싱가포르에 세워진 디자인 학교입니다.전 세계적으로 31개의 학교가 있고 실습 위주의 교육 강화를 통해 학생들은 기술개발을 할 수 있습니다. 포트폴리오가 필요없으며 3년안에 학위 취득을 할 수 있습니다. 세계 여러나라의 캠퍼스에서 같은 커리큘럼을 제공하며 싱가포르는 특히 디자인전공이 유명합니다. 그외에도 비즈니스, 호텔경영 과정들이 개설되어 있습니다.'
    },
    {
        thumb: '../img/privateuni-thumb/jcu-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/HSdg5YTgQ5o',
        img: '../img/privateuni-thumb/jcu-main.png',
        title: 'JCU',
        fullTitle: 'James Cook University Singapore',
        student: '~3,000명',
        semester: '3월 | 7월 | 11월',
        fee:'~$S96,000',
        intro: '호주 퀸스랜드 타운스빌에 본교를 두고 있으며 세계적으로 300위권에 랭크되어 있습니다. 약 17000여명이 재학하고 있는 역사가 오래된 대학입니다. 싱가포르 분교는 현재 3000여명의 학생이 재학하고 있으며 호주 본교와 동일한 커리큘렴을 제공하며 본교 교수들이 교차강의를 합니다. 호주 본교의 총 3년 학사과정을 싱가포르에서는 2년에 마칠 수 있으며 동일한 학비로 호주 본교에서 2학기를 다닐 수 있습니다. 학비가 호주 본교보다 저렴합니다.'
    },
    {
        thumb: '../img/privateuni-thumb/kaplan-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/gRaiAumKVjQ',
        img: '../img/privateuni-thumb/kaplan-main.jpg',
        title: 'KAPLAN',
        fullTitle: 'Kaplan Higher Education Academy',
        student: '~18,000명',
        semester: '2월 | 6월 | 12월',
        fee:'~$S47,000',
        intro: 'Kaplan은 세계 최대규모의 교육 그룹으로 싱가포르에 2005년에 설립 되었으며 35개국에서 온 학생들에게 500여개의 학업 프로그램을 제공하고 있으며 현재까지 65,000명 이상의 졸업생을 배출 하였습니다. 학생들에게 우수한 교육 및 서비스를 제공하여 3년 연속 최고의 사립 교육기관으로 선정 되었으며 싱가포르 교육기관 선호도를 조사하는 기관 Job Central에서 1위에 선정되었습니다.'
    },
    {
        thumb: '../img/privateuni-thumb/curtin-thumb.jpg',
        youtube: 'https://www.youtube.com/embed/vhmyIRylPaw',
        img: '../img/privateuni-thumb/curtin-main.jpg',
        title: 'Curtin',
        fullTitle: 'Curtin Singapore',
        student: '~18,000명',
        semester: '2월 | 6월 | 12월',
        fee:'~$S51,000',
        intro: 'Curtin은 호주에서 3번째로 많은 외국학생을 가지고 있는 Curtin University가 2008년에 싱가포르에 설립한 분교입니다. 2019-20년 QS 세계 대학 순위에서 세계 230위로 랭크되었으며 2018 QILT(Quality Indicators for Learning and Teaching) 보고서에 따르면 대학원 학위를 받은 졸업생은 서호주 졸업생 중 가장 높은 급여를 받았습니다. 2년 안에 학위를 취득할 수 있고 호주 본교에서 교차 강의를 들을 수 있습니다.'
    },
]

export default PriUniData

